/* @ngInject */

export default (helperService) => {
  /**
   * Get total food expenses.
   *
   * @param {Array} expenses
   *
   * @returns {Number}
   */
  const getTotalFoodExpenses = (expenses, isShortVersion) => {
    let totalFoodExpenses = 0;
    if (expenses && isShortVersion) {
      totalFoodExpenses =
        helperService.isNumber(expenses.personal.foodAndSupermarketItems, true) *
        helperService.getFrequencyValue(
          expenses.personal.foodAndSupermarketItemsFrequency,
          true
        );
    } else if (expenses && !isShortVersion) {
      totalFoodExpenses =
        helperService.isNumber(expenses.personal.foodAndSupermarketItems, true) *
          helperService.getFrequencyValue(
            expenses.personal.foodAndSupermarketItemsFrequency,
            true
          ) +
        helperService.isNumber(expenses.personal.coffeeLunchesTakeaway, true) *
          helperService.getFrequencyValue(
            expenses.personal.coffeeLunchesTakeawayFrequency,
            true
          ) +
        helperService.isNumber(expenses.personal.cigarettesAndAlcohol, true) *
          helperService.getFrequencyValue(
            expenses.personal.cigarettesAndAlcoholFrequency,
            true
          );
    }
    return totalFoodExpenses;
  };

  /**
   * Get total discretionary expenses.
   *
   * @param {Array} expenses
   *
   * @returns {Number}
   */
  const getTotalDiscretionaryExpenses = (expenses, isShortVersion) => {
    let totalDiscretionaryExpenses = 0;
    if (expenses && isShortVersion) {
      totalDiscretionaryExpenses =
        helperService.isNumber(expenses.personal.phoneInternetPayTV, true) *
          helperService.getFrequencyValue(expenses.personal.phoneInternetPayTVFrequency, true) +
        helperService.isNumber(expenses.personal.entertainment, true) *
          helperService.getFrequencyValue(expenses.personal.entertainmentFrequency, true) +
        helperService.isNumber(expenses.personal.other, true) *
          helperService.getFrequencyValue(expenses.personal.otherFrequency, true);
    } else if (expenses && !isShortVersion) {
      totalDiscretionaryExpenses =
        helperService.isNumber(expenses.personal.clothingShoesAccessories, true) *
          helperService.getFrequencyValue(
            expenses.personal.clothingShoesAccessoriesFrequency,
            true
          ) +
        helperService.isNumber(expenses.personal.phoneInternetPayTV, true) *
          helperService.getFrequencyValue(expenses.personal.phoneInternetPayTVFrequency, true) +
        helperService.isNumber(expenses.personal.hairdressingGrooming, true) *
          helperService.getFrequencyValue(
            expenses.personal.hairdressingGroomingFrequency,
            true
          ) +
        helperService.isNumber(expenses.personal.entertainment, true) *
          helperService.getFrequencyValue(expenses.personal.entertainmentFrequency, true) +
        helperService.isNumber(expenses.personal.giftsAndCelebrations, true) *
          helperService.getFrequencyValue(
            expenses.personal.giftsAndCelebrationsFrequency,
            true
          ) +
        helperService.isNumber(expenses.personal.holidays, true) *
          helperService.getFrequencyValue(expenses.personal.holidaysFrequency, true) +
        helperService.isNumber(expenses.personal.petsFoodCareVet, true) *
          helperService.getFrequencyValue(expenses.personal.petsFoodCareVetFrequency, true) +
        helperService.isNumber(expenses.personal.other, true) *
          helperService.getFrequencyValue(expenses.personal.otherFrequency, true);
    }
    return totalDiscretionaryExpenses;
  };

  /**
   * Get total children and education expenses.
   *
   * @param {Array} expenses
   *
   * @returns {Number}
   */
  const getTotalChildrenAndEducationExpenses = (expenses) => {
    let totalChildrenAndEducationExpenses = 0;
    if (expenses) {
      totalChildrenAndEducationExpenses =
        helperService.isNumber(expenses.personal.schoolFeesUniformsEducation, true) *
          helperService.getFrequencyValue(
            expenses.personal.schoolFeesUniformsEducationFrequency,
            true
          ) +
        helperService.isNumber(expenses.personal.childCare, true) *
          helperService.getFrequencyValue(expenses.personal.childCareFrequency, true) +
        helperService.isNumber(expenses.personal.childMaintenance, true) *
          helperService.getFrequencyValue(expenses.personal.childMaintenanceFrequency, true);
    }
    return totalChildrenAndEducationExpenses;
  };

  /**
   * Get total health and wellness expenses.
   *
   * @param {Array} expenses
   *
   * @returns {Number}
   */
  const getTotalHealthAndWellnessExpenses = (expenses, isShortVersion) => {
    let totalHealthAndWellnessExpenses = 0;
    if (expenses && isShortVersion) {
      totalHealthAndWellnessExpenses =
        helperService.isNumber(expenses.personal.privateHealthInsurance, true) *
          helperService.getFrequencyValue(
            expenses.personal.privateHealthInsuranceFrequency,
            true
          ) +
        helperService.isNumber(expenses.personal.lifeTraumaIncomeInsurances, true) *
          helperService.getFrequencyValue(
            expenses.personal.lifeTraumaIncomeInsurancesFrequency,
            true
          ) +
        helperService.isNumber(expenses.personal.anyOtherInsurances, true) *
          helperService.getFrequencyValue(expenses.personal.anyOtherInsurancesFrequency, true);
    } else if (expenses && !isShortVersion) {
      totalHealthAndWellnessExpenses =
        helperService.isNumber(expenses.personal.gymFeesSport, true) *
          helperService.getFrequencyValue(expenses.personal.gymFeesSportFrequency, true) +
        helperService.isNumber(expenses.personal.privateHealthInsurance, true) *
          helperService.getFrequencyValue(
            expenses.personal.privateHealthInsuranceFrequency,
            true
          ) +
        helperService.isNumber(expenses.personal.doctorDentistPharmacy, true) *
          helperService.getFrequencyValue(
            expenses.personal.doctorDentistPharmacyFrequency,
            true
          ) +
        helperService.isNumber(expenses.personal.glassesAndEyeCare, true) *
          helperService.getFrequencyValue(expenses.personal.glassesAndEyeCareFrequency, true) +
        helperService.isNumber(expenses.personal.lifeTraumaIncomeInsurances, true) *
          helperService.getFrequencyValue(
            expenses.personal.lifeTraumaIncomeInsurancesFrequency,
            true
          ) +
        helperService.isNumber(expenses.personal.anyOtherInsurances, true) *
          helperService.getFrequencyValue(expenses.personal.anyOtherInsurancesFrequency, true);
    }
    return totalHealthAndWellnessExpenses;
  };

  /**
   * Get total transportation expenses.
   *
   * @param {Array} expenses
   *
   * @returns {Number}
   */
  const getTotalTransportationExpenses = (expenses, isShortVersion) => {
    let totalTransportationExpenses = 0;
    if (expenses && isShortVersion) {
      totalTransportationExpenses =
        helperService.isNumber(expenses.transportation.motorVehicleInsurance, true) *
          helperService.getFrequencyValue(
            expenses.transportation.motorVehicleInsuranceFrequency,
            true
          ) +
        helperService.isNumber(expenses.transportation.fuelTollsParking, true) *
          helperService.getFrequencyValue(
            expenses.transportation.fuelTollsParkingFrequency,
            true
          ) +
        helperService.isNumber(expenses.transportation.repairsServicingTyres, true) *
          helperService.isNumber(expenses.transportation.repairsServicingTyresFrequency, true);
    } else if (expenses && !isShortVersion) {
      totalTransportationExpenses =
        helperService.isNumber(expenses.transportation.motorVehicleInsurance, true) *
          helperService.getFrequencyValue(
            expenses.transportation.motorVehicleInsuranceFrequency,
            true
          ) +
        helperService.isNumber(expenses.transportation.motorVehicleRegistration, true) *
          helperService.getFrequencyValue(
            expenses.transportation.motorVehicleRegistrationFrequency,
            true
          ) +
        helperService.isNumber(expenses.transportation.fuelTollsParking, true) *
          helperService.getFrequencyValue(
            expenses.transportation.fuelTollsParkingFrequency,
            true
          ) +
        helperService.isNumber(expenses.transportation.repairsServicingTyres, true) *
          helperService.getFrequencyValue(
            expenses.transportation.repairsServicingTyresFrequency,
            true
          ) +
        helperService.isNumber(expenses.transportation.busTrainTramFerry, true) *
          helperService.getFrequencyValue(
            expenses.transportation.busTrainTramFerryFrequency,
            true
          ) +
        helperService.isNumber(expenses.transportation.carShareUberTaxi, true) *
          helperService.getFrequencyValue(
            expenses.transportation.carShareUberTaxiFrequency,
            true
          );
    }
    return totalTransportationExpenses;
  };

  /**
   * Get total property expenses.
   *
   * @param {Array} expenses
   *
   * @returns {Number}
   */
  const getTotalPropertyExpenses = (expenses, isShortVersion, useRentalProperty) => {
    let totalPropertyExpenses = 0;
    if (expenses && isShortVersion) {
      totalPropertyExpenses =
        (useRentalProperty
          ? helperService.isNumber(expenses.property.currentRental, true) *
            helperService.getFrequencyValue(expenses.property.currentRentalFrequency, true)
          : 0) +
        helperService.isNumber(expenses.property.ratesBodyCorpOwnerOccupied, true) *
          helperService.getFrequencyValue(
            expenses.property.ratesBodyCorpOwnerOccupiedFrequency,
            true
          ) +
        helperService.isNumber(expenses.property.electricityGasWater, true) *
          helperService.getFrequencyValue(
            expenses.property.electricityGasWaterFrequency,
            true
          ) +
        helperService.isNumber(expenses.property.ratesBodyCorpInvestment, true) *
          helperService.getFrequencyValue(
            expenses.property.ratesBodyCorpInvestmentFrequency,
            true
          );
    } else if (expenses && !isShortVersion) {
      totalPropertyExpenses =
        (useRentalProperty
          ? helperService.isNumber(expenses.property.currentRental, true) *
            helperService.getFrequencyValue(expenses.property.currentRentalFrequency, true)
          : 0) +
        helperService.isNumber(expenses.property.homeAndContentsInsurance, true) *
          helperService.getFrequencyValue(
            expenses.property.homeAndContentsInsuranceFrequency,
            true
          ) +
        helperService.isNumber(expenses.property.ratesBodyCorpOwnerOccupied, true) *
          helperService.getFrequencyValue(
            expenses.property.ratesBodyCorpOwnerOccupiedFrequency,
            true
          ) +
        helperService.isNumber(expenses.property.electricityGasWater, true) *
          helperService.getFrequencyValue(
            expenses.property.electricityGasWaterFrequency,
            true
          ) +
        helperService.isNumber(expenses.property.repairsMaintenancePool, true) *
          helperService.getFrequencyValue(
            expenses.property.repairsMaintenancePoolFrequency,
            true
          ) +
        helperService.isNumber(expenses.property.ratesBodyCorpInvestment, true) *
          helperService.getFrequencyValue(
            expenses.property.ratesBodyCorpInvestmentFrequency,
            true
          );
    }
    return totalPropertyExpenses;
  };

  /**
   * Get total property expenses temporary.
   *
   * @param {Array} expenses
   *
   * @returns {Number}
   */
  const getTotalPropertyExpensesTemporary = (expenses) => {
    let totalPropertyExpenses = 0;
    if (expenses) {
      totalPropertyExpenses =
        helperService.isNumber(expenses.property.homeAndContentsInsurance, true) *
          helperService.getFrequencyValue(
            expenses.property.homeAndContentsInsuranceFrequency,
            true
          ) +
        helperService.isNumber(expenses.property.ratesBodyCorpOwnerOccupied, true) *
          helperService.getFrequencyValue(
            expenses.property.ratesBodyCorpOwnerOccupiedFrequency,
            true
          ) +
        helperService.isNumber(expenses.property.electricityGasWater, true) *
          helperService.getFrequencyValue(
            expenses.property.electricityGasWaterFrequency,
            true
          ) +
        helperService.isNumber(expenses.property.repairsMaintenancePool, true) *
          helperService.getFrequencyValue(
            expenses.property.repairsMaintenancePoolFrequency,
            true
          ) +
        helperService.isNumber(expenses.property.ratesBodyCorpInvestment, true) *
          helperService.getFrequencyValue(
            expenses.property.ratesBodyCorpInvestmentFrequency,
            true
          );
    }
    return totalPropertyExpenses;
  };

  /**
   * Get total children and education expenses temporary.
   *
   * @param {Array} expenses
   *
   * @returns {Number}
   */
  const getTotalChildrenAndEducationExpensesTemporary = (expenses) => {
    let totalChildrenAndEducationExpenses = 0;
    if (expenses) {
      totalChildrenAndEducationExpenses =
        helperService.isNumber(expenses.personal.schoolFeesUniformsEducation, true) *
          helperService.getFrequencyValue(
            expenses.personal.schoolFeesUniformsEducationFrequency,
            true
          ) +
        helperService.isNumber(expenses.personal.childCare, true) *
          helperService.getFrequencyValue(expenses.personal.childCareFrequency, true);
    }
    return totalChildrenAndEducationExpenses;
  };

  /**
   * Get total other commitments expenses.
   *
   * @param {Array} expenses
   *
   * @returns {Number}
   */
  const getTotalOtherCommitmentsExpenses = (expenses) => {
    let totalOtherExpenses = 0;
    if (expenses) {
      totalOtherExpenses =
        helperService.isNumber(expenses.personal.childMaintenance, true) *
          helperService.getFrequencyValue(expenses.personal.childMaintenanceFrequency, true) +
        helperService.isNumber(expenses.property.currentRental, true) *
          helperService.getFrequencyValue(expenses.property.currentRentalFrequency, true);
    }
    return totalOtherExpenses;
  };

  /**
   * Get total expenses.
   *
   * @param {Array} expenses
   * @param {Boolean} isShortVersion
   * @param {Boolean} useRentalProperty
   *
   * @returns {Number}
   */
  const getTotalExpenses = (expenses, isShortVersion, useRentalProperty) => {
    let total = 0;
    if (expenses) {
      total =
        getTotalFoodExpenses(expenses, isShortVersion) +
        getTotalDiscretionaryExpenses(expenses, isShortVersion) +
        getTotalChildrenAndEducationExpenses(expenses) +
        getTotalHealthAndWellnessExpenses(expenses, isShortVersion) +
        getTotalTransportationExpenses(expenses, isShortVersion) +
        getTotalPropertyExpenses(expenses, isShortVersion, useRentalProperty);
    }
    return total;
  };

  return {
    getTotalFoodExpenses,
    getTotalDiscretionaryExpenses,
    getTotalChildrenAndEducationExpenses,
    getTotalHealthAndWellnessExpenses,
    getTotalTransportationExpenses,
    getTotalPropertyExpenses,
    getTotalPropertyExpensesTemporary,
    getTotalChildrenAndEducationExpensesTemporary,
    getTotalOtherCommitmentsExpenses,
    getTotalExpenses
  };
};
